import { ICreateEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/create-entity-failure-payload.interface';

export class CreateUserFailure {
    static readonly type = '[User] CreateUserFailure';

    constructor(public payload: ICreateEntityFailureActionPayload) {}
}
